module.exports = __webpack_public_path__ + "img/office-layout.80d201c2.png";